module.exports = __webpack_public_path__ + "img/select_count.png";